<ion-row class="ion-align-items-center">
  <div class="c-container-div">
    <ion-icon color="primary" slot="start" name="information-circle-outline" (click)="onOpenPopoverTooltipClick($event)"></ion-icon>
  </div>
</ion-row>